class QuizHandler {
	constructor() {
		this._postId = $('body').data('post-id');
		this._quizUI = QuizUI.getInstance();
		this._aloomaData = {};
		this._chosenVariation = null;

		if (this._quizUI.$quiz.length) {
			this._quizId = this._quizUI.$quiz.data('id');
			this._quizQuestions = new QuizQuestions(
				this._quizUI.$quiz.data('questions'),
				this._quizUI.$quiz.data('current-step-index')
			);
			this._template = this._quizUI.$quiz.data('template');
		} else {
			this._quizQuestions = null;
		}

		this._redirectTimer = null;
	}

	/**
	 * @return {QuizHandler}
	 */
	static getInstance() {
		return new QuizHandler();
	}

	init() {
		if (!this._quizUI.$quiz.length) {
			return;
		}

		const self = this;

		$(document).on('click', '.quiz .answers-container .answer-button', function (e) {
			e.preventDefault();

			const $answerButton = $(this);
			const answerKey = $answerButton.data('answer-key');
			const prevQuestion = self._quizQuestions.current();
			const isLastQuestion = self._quizQuestions.isLastQuestion;

			self._quizQuestions.next(answerKey);
			self._hideOrShowGoBackButton();

			if (isLastQuestion) {
				self._initAloomaData(prevQuestion, answerKey);
			} else {
				self._sendAloomaAnswerButtonClick(prevQuestion, answerKey);
			}
		});

		self._quizUI.$goBackButton.on('click', self._goBackClick.bind(self));

		$(document).on('quiz-last-question', function (e, {selectedAnswers}) {
			if (self._template) {
				self._quizUI.$quiz.addClass('loading');
			}

			jQuery.post(ajaxurl, {
				action: 'quiz-get-vendor',
				quizId: self._quizId,
				postId: self._postId,
				chosenVariation: self._chosenVariation,
				selectedAnswers,
				template: self._template ? self._template : '',
			}, function (response) {
				self._quizUI.hideLoader();
				if (self._template) {
					self._quizUI.$quiz.removeClass('loading');
				}

				if (response && response['html']) {
					self._quizUI.setResultVendorHtml(response['html']);
					self._quizUI.$quiz.addClass('quiz-result');

					if (response['result_text']) {
						self._quizUI.setResultText(response['result_text']);
					}

					if (response['result_subtext']) {
						self._quizUI.setResultSubText(response['result_subtext']);
					}

					self._updateMainClass(response['has_more_vendors']);
					self._addAloomaClickoutToResultVendor();
					self._sendAloomaFoundVendor(self._quizUI.getResultVendor().data('vendorSlug'));

					const goBackBtn = self._quizUI.$quiz.find('#go_back_btn');
					if (goBackBtn) {
						goBackBtn.on('click', self._goBackClick.bind(self));
					}

					if (response['make_redirect'] === true) {
						const redirectLinkElement = self._quizUI.$quiz.find('.redirect-link').get(0);
						if (redirectLinkElement) {
							self._redirectTimer = setTimeout(() => {
								self._sendAloomaResultVendorEvent(redirectLinkElement);
								window.location.href = redirectLinkElement.href;
							}, 2000);

							const timeElement = self._quizUI.$quiz.find('#loader_time').get(0);
							if (timeElement) {
								let spendTime = 2;

								const loaderInterval = setInterval(() => {
									spendTime--;

									if (spendTime < 0) {
										clearInterval(loaderInterval);
										timeElement.innerHTML = '';
									} else {
										timeElement.innerHTML = spendTime + ' seconds';
									}
								}, 1000);
							}
						}
					}
				} else {
					self._quizUI.setResultText('');
					self._quizUI.setResultSubText('');
					self._quizUI.setResultVendorHtml('<div class="no-vendor-found">' + 'Sorry, no vendor found.' + '</div>');

					self._quizUI.$quiz.addClass('not-found');
				}
			}, 'json');
		});

		$(window).on('resize', function () {
			self._quizUI.updateCssHalfHeightOfTheQuizBlock();
		});

		this._initChosenVariation();
		this._initScrollListening();
	}

	_goBackClick(e) {
		e.preventDefault();

		if (this._redirectTimer) {
			clearTimeout(this._redirectTimer);
		}

		this._quizQuestions.prev();
		this._quizUI.$quiz.removeClass('result-vendors');
		this._quizUI.$quiz.removeClass('quiz-result');
		this._quizUI.$quiz.removeClass('not-found');
		this._hideOrShowGoBackButton();
	}

	_initChosenVariation() {
		const cookies = document.cookie.split('; ');
		const postId = $('body').data('post-id');
		const neededKey = 'chosen_variation_' + postId + '_' + postId;

		for (const cookie of cookies) {
			const [cookieKey, cookieValue] = cookie.split('=');

			if (cookieKey === neededKey) {
				this._chosenVariation = cookieValue;
				break;
			}
		}
	}

	_initScrollListening() {
		const quiz = this._quizUI.$quiz.get(0);

		if (!quiz) {
			return;
		}

		let theQuizWasShown = false;
		const aloomaData = {
			pageview_id: aloomaPageData.pageview_id,
			quiz: {
				step: 'step_0',
			},
		};

		window.addEventListener('scroll', function (e) {
			if (!theQuizWasShown && quiz.getBoundingClientRect().top >= 0 && quiz.getBoundingClientRect().bottom <= window.innerHeight) {
				theQuizWasShown = true;
				aloomaSendEvent('quiz_change', aloomaData);
			}
		});
	}

	_sendAloomaAnswerButtonClick(prevQuestion, answerKey) {
		if (typeof aloomaSendEvent === 'undefined') {
			return;
		}

		this._initAloomaData(prevQuestion, answerKey);
		const aloomaData = {...this._aloomaData}

		aloomaSendEvent('quiz_change', aloomaData);
	}

	/**
	 * @param {QuizQuestion} prevQuestion
	 * @param {string} answerKey
	 * @private
	 */
	_initAloomaData(prevQuestion, answerKey) {
		this._aloomaData = {
			pageview_id: aloomaPageData.pageview_id,
			quiz: {
				step: 'step_' + (prevQuestion.stepIndex + 1),
				question: prevQuestion.key,
				answer: answerKey,
			},
		};
	}

	_sendAloomaFoundVendor(vendor) {
		if (typeof aloomaSendEvent === 'undefined' || !vendor) {
			return;
		}

		const aloomaData = {...this._aloomaData}
		aloomaData.quiz.suggested_vendor = vendor;

		aloomaSendEvent('quiz_change', aloomaData);
	}

	_addAloomaClickoutToResultVendor() {
		if (typeof applyAloomaTracking !== 'undefined') {
			applyAloomaTracking();
		}
	}

	_sendAloomaResultVendorEvent($vendorCta) {
		if (typeof aloomaSendEvent === 'undefined') {
			return;
		}

		const linkId = $vendorCta.dataset.linkid;
		if (typeof aloomaClicksData[linkId] !== 'undefined') {
			aloomaSendEvent('clickout', aloomaClicksData[linkId]);
		}
	}

	_hideOrShowGoBackButton() {
		if (this._quizQuestions.currentStepIndex === 0) {
			this._quizUI.$goBackButton.addClass('visibility-hidden');
		} else {
			this._quizUI.$goBackButton.removeClass('visibility-hidden');
		}
	}

	_showDisclaimer() {
		this._quizUI.$quizDisclaimer.css('visibility', 'visible');
		this._quizUI.$quizDisclaimer.css('height', 'auto');
	}

	_updateMainClass(hasMoreVendors) {
		if (hasMoreVendors) {
			if (!this._quizUI.$quiz.hasClass('result-vendors')) {
				this._quizUI.$quiz.addClass('result-vendors');
			}
		}
	}
}
